/** The app's error screen; its button full-reloads, which is also the only retry that clears a stale route chunk. */
export function ErrorFallbackContent() {
	return (
		<div className="flex flex-col items-center justify-center min-h-[50vh] text-center px-4">
			<h1 className="text-2xl font-semibold mb-4">Something went wrong</h1>
			<p className="text-gray-500 mb-8">An unexpected error occurred. Please refresh the page and try again.</p>
			<button
				className="px-6 py-2 bg-black text-white rounded"
				onClick={() => window.location.reload()}
			>
				Refresh Page
			</button>
		</div>
	);
}
